import { func, object, shape, bool, string } from 'prop-types';
import React from 'react';
import BEMHelper from '@ynap/bem-helper';
import { CombinedImage } from '@ynap/image';

const bem = new BEMHelper('UnavailableProductPage');

const generateImageSrcsetSize = () => '105px';

const UnavailableProductPage = ({ product, loading, productImageAspectRatio, messages }) => {
    const imageSrcsetSize = generateImageSrcsetSize();

    const { imgSrc, designerName, name } = product || {};

    return (
        <div className={bem(null)}>
            <div className={bem('content')}>
                <div className={bem('imageContainer')}>
                    <CombinedImage
                        src={imgSrc?.primary}
                        alt={name}
                        loading={loading}
                        yOffset={'0%'}
                        aspectRatio={productImageAspectRatio}
                        imageSrcsetSize={imageSrcsetSize}
                        primarySrcset={imgSrc?.primarySrcset}
                        displayError={!(loading || imgSrc?.primary)}
                        withIntersectionObserver={true}
                        withSkeleton={true}
                        hideSecondaryOnMobile={true}
                    />
                </div>
                <div className={bem('info')}>
                    <label className={bem('designer')}>{designerName}</label>
                    <label className={bem('name')}>{name}</label>
                </div>
            </div>
            <div className={bem('footer')}>
                <i></i>
                <label>{messages?.product?.unavailableProduct()}</label>
            </div>
        </div>
    );
};

UnavailableProductPage.propTypes = {
    product: object.isRequired,
    messages: shape({
        product: shape({
            unavailableProduct: func.isRequired,
        }).isRequired,
    }),
    loading: bool,
    productImageAspectRatio: string,
};

export default UnavailableProductPage;
